
import Hero from "../components/Hero";
import HomeCategories from "../components/HomeCategories";
import HomeDiscounts from "../components/HomeDiscounts";
import HomeSlogan from "../components/HomeSlogan";
import HomeCollections from "../components/HomeCollections";
import HomeBestsellers from "../components/HomeBestsellers";
import HomeAthleteReviews from "../components/HomeAthleteReviews";
import Category from "../components/Category";
import FormInput from "../components/FormInput";
import Btn from "../components/Btn";
import FormTextarea from "../components/FormTextarea";
import {
    createItemListSchema,
    createSchemaHead,
    getAbsoluteImageUrl,
    getAbsoluteUrl,
    getCanonicalUrl,
    getSiteCurrency,
    getSiteName,
} from "../utils/schema";
export default {
    name: 'IndexPage',
    components: {HomeAthleteReviews, HomeBestsellers, HomeCollections, HomeSlogan, HomeDiscounts, FormTextarea, Btn, FormInput, Category, Hero, HomeCategories},
    async asyncData({ $axios }) {
        const res = await $axios.get('api/v1/products/main');

        return {
            h1: res.data.homepage.seo_h1,
            title: res.data.homepage.seo_title,
            description: res.data.homepage.seo_description,
            products: res.data.products || [],
            bannerHead: res.data.bannerHead,
            bannerMain: res.data.bannerMain,
            collections: res.data.collections || [],
            bestsellers: res.data.bestsellers || [],
            athleteReviews: res.data.athlete_reviews || [],
        }
    },
    head() {
        const canonical = getCanonicalUrl(this);
        const itemList = createItemListSchema(this, this.discountProducts.map((product) => ({
            name: product.name,
            url: getAbsoluteUrl(this, `/catalog/product/${product.alias}/`),
            image: getAbsoluteImageUrl(this, product.image && product.image.sizes ? (product.image.sizes.medium || product.image.path) : null),
            price: product.price_special || product.price || null,
            available: product.available,
            currency: getSiteCurrency(this),
        })), '#homepage-items');
        const schemaHead = createSchemaHead([
            {
                '@type': 'WebSite',
                '@id': `${canonical}#website`,
                url: canonical,
                name: getSiteName(this),
            },
            {
                '@type': 'CollectionPage',
                '@id': `${canonical}#webpage`,
                url: canonical,
                name: this.title || getSiteName(this),
                description: this.description || undefined,
                isPartOf: {
                    '@id': `${canonical}#website`,
                },
                mainEntity: itemList ? {
                    '@id': itemList['@id'],
                } : undefined,
            },
            itemList,
        ], 'schema-org-home');

        return {
            title: this.title,
            meta: [
                { hid: 'description', name: 'description', content: this.description, },
                { hid: 'keywords', name: 'keywords', content: '' },
            ],
            link: [
                { hid: 'canonical', rel: 'canonical', href: canonical },
            ],
            ...schemaHead,
        }
    },
    data() {
        return {
            seo: false,
            process: false,
            editMode: false,
            editModeProcess: false,
        }
    },
    mounted() {
        if (this.$ecommerce && this.discountProducts.length > 0) {
            this.$ecommerce.impressions(this.discountProducts, 'Homepage discounts');
        }
    },
    computed: {
        discountProducts() {
            return this.products.filter((product) => {
                const price = Number(product.price);
                const priceBase = Number(product.price_base);

                return product.show_in_discounts === true && price > 0 && priceBase > 0 && price < priceBase;
            });
        },
    },
    methods: {
        async changeEditMode(){
            if(this.editModeProcess){
                return;
            }

            this.editMode = !this.editMode;
            this.editModeProcess = true;
            try {
                const res = await this.$axios.get('api/v1/products/main', {
                    params: {
                        editMode: this.editMode
                    },
                });

                this.products = res.data.products;
                this.editModeProcess = false;
            } catch (e) {
                alert('При изменении режима редактирования возникла ошибка');
                this.editModeProcess = false;
            }
        },
        async changeMainSkip(id){
            this.editModeProcess = true;
            try {
                let response = await this.$axios.post('/api/v1/products/change-main-skip',{
                    id: id,
                    editMode: this.editMode,
                });
                this.products = response.data.products;
                this.editModeProcess = false;
            } catch (e) {
                alert('При изменении видимости товара произошла ошибка');
                this.editModeProcess = false;
            }
        },
        async changeMainRating(id, rating){
            this.editModeProcess = true;
            try {
                let response = await this.$axios.post('/api/v1/products/change-main-rating',{
                    id: id,
                    rating: rating,
                    editMode: this.editMode,
                });
                this.products = response.data.products;
                this.editModeProcess = false;
            } catch (e) {
                alert('При изменении видимости товара произошла ошибка');
                this.editModeProcess = false;
            }
        },
        async submit(){
            this.process = true;
            try {
                let response = await this.$axios.post('/api/v1/seo/homepage', {
                    seo_h1: this.h1,
                    seo_title: this.title,
                    seo_description: this.description,
                });
                this.process = false;
                this.seo = false;
            } catch (e) {
                if (e.response.status === 422) {
                    this.error = 'Некорректно отправлена форма';
                } else {
                    this.error = 'Системная ошибка, попробуйте позже';
                }
                alert(this.error);
                this.process = false;
            }
        },
    },
}
